import React, { useRef, useCallback } from "react";
import {
  TextField,
  TextFieldLabel,
  TextFieldTextArea,
} from "@hireart/component-library";
import PropTypes from "prop-types";
import { ShiftShape } from "common/utils/timesheet";
import { applyMobileInputStyles, removeMobileInputStyles } from "./utils";

export const ShiftNotesSection = React.memo(
  ({ shift, isReadOnly, onNotesChange = undefined }) => {
    const textareaRef = useRef(null);

    // Handle focus with mobile-specific fixes
    const handleFocus = useCallback((e) => {
      // Prevent viewport zoom on mobile by setting font-size to 16px or larger
      // This is a common fix for iOS Safari textarea focus issues
      applyMobileInputStyles(e.target);

      // Add a small delay to ensure the textarea is properly focused
      // before any potential drawer animations complete
      setTimeout(() => {
        if (textareaRef.current) {
          textareaRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);
    }, []);

    // Handle blur to reset font size
    const handleBlur = useCallback((e) => {
      removeMobileInputStyles(e.target);
    }, []);
    return (
      <div className="mb-6 flex flex-col gap-2">
        <TextField isOptional isDisabled={isReadOnly}>
          <TextFieldLabel htmlFor="notes" isUnstyled>
            Shift notes
          </TextFieldLabel>
          <TextFieldTextArea
            ref={textareaRef}
            id="notes"
            className={isReadOnly ? "cursor-not-allowed bg-neutral-20" : ""}
            placeholder={
              isReadOnly
                ? "No notes available"
                : "Add notes about this shift..."
            }
            value={shift.notes || ""}
            onChange={(e) => onNotesChange?.(e.target.value)}
            onFocus={handleFocus}
            onBlur={handleBlur}
            size="sm"
            // Add mobile-specific attributes to prevent zoom and improve touch handling
            style={{
              touchAction: "manipulation",
            }}
          />
        </TextField>
      </div>
    );
  }
);
ShiftNotesSection.propTypes = {
  shift: ShiftShape.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  onNotesChange: PropTypes.func,
};
